import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import SkipLink from './SkipLink';

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div
            className="flex h-screen overflow-hidden"
            style={{ background: 'var(--dark-bg)' }}
        >
            {/* Accessibility: Skip link for keyboard users */}
            <SkipLink />

            {/* Navigation sidebar */}
            <Sidebar />

            {/* Main content area with proper landmark */}
            <main
                id="main-content"
                className="flex-1 overflow-y-auto blueprint-grid"
                role="main"
                tabIndex={-1}
                aria-label="Main content"
                style={{ background: 'var(--dark-bg)' }}
            >
                {children}
            </main>
        </div>
    );
}
